import type { App } from 'vue';
import { createI18n } from 'vue-i18n';
import type { LocaleMessages } from 'vue-i18n';
import { localStg } from '@/utils';
import messages from './lang';

const i18n = createI18n({
  locale: localStg.get('lang') || 'zh-CN',
  fallbackLocale: 'api',
  messages,
  legacy: false
});

export function setupI18n(app: App) {
  app.use(i18n);
}

export function t(key: string, formatter?: any) {
  // @ts-ignore
  return i18n.global.t(key, formatter);
}

export function please(key: string, ty?: string) {
  if (ty !== 's') {
    return t('common.inputText') + t(key);
  }
  return t('common.chooseText') + t(key);
}

export function setLocaleMessage(apiLang: LocaleMessages<any, string>) {
  i18n.global.setLocaleMessage('api', apiLang);
}
